import { createBaseAction } from '@essent/common';
import { createAction } from '@ngrx/store';

export const enum GetRetentionOfferTypes {
  GET = '[Retention] Get offer',
  SET_FLOWID = '[Retention] Set selected flowid',
}

export const getOfferAction = createAction(GetRetentionOfferTypes.GET);
export const setSelectedFlowIdAction = createBaseAction<string>(
  GetRetentionOfferTypes.SET_FLOWID
);
